import {  InputHTMLAttributes } from "react";

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}
export default function ({ ...rest }: Props) {
  return (
    <textarea
      {...rest}
      className={
        "peer block w-full rounded-md border border-gray-200 py-2 pl-2 text-sm outline-2 placeholder:text-gray-500"
      }
    />
  );
}
